import React, { useCallback, useState } from 'react';

import { Button, Checkbox, Flexer, SegmentedButton, Spacer, Textarea } from '@ontruck/orc';

import ShipperOrderTag from 'modules/shipper-order/Tag';

import StyledShipperOrders, { StyledJourneyTag, StyledLogAssignation } from './styled';
import { StyledItem } from 'modules/log/LogItem/styled';

import ActionName from 'modules/log/LogItem/modes/common/ActionName';

import { LOG_INCIDENT, LOG_INFO } from 'modules/log/log-reasons';

import useEditionMode from 'modules/log/LogItem/modes/common/useEditionMode';
import { injectIntl } from 'react-intl';

const CreateMode = ({
  action,
  shipperOrderId,
  journeyId,
  shipperOrdersSkin = {},
  onSubmit,
  onCancel,
  intl,
}) => {
  const t = intl.messages.modules.logs.log_item;
  const shipperOrders = Object.keys(shipperOrdersSkin);
  const multipleShipperOrders = shipperOrders.length > 1;

  const [selectedShipperOrders, setShipperOrders] = useState(
    shipperOrderId ? [shipperOrderId] : []
  );

  const { comment, logType, handleTextareaChange, handleLogTypeChange, textAreaRef } =
    useEditionMode();

  const handleShipperOrdersChange = useCallback(
    (e, { name: shipperOrderId, value }) => {
      if (value) {
        setShipperOrders([...selectedShipperOrders, shipperOrderId]);
        return;
      }
      setShipperOrders([...selectedShipperOrders.filter((id) => id !== shipperOrderId)]);
    },
    [selectedShipperOrders, setShipperOrders]
  );

  const handleSaveClick = useCallback(() => {
    onSubmit &&
      onSubmit({
        action,
        comment,
        journeyId,
        log_type: logType,
        shipperOrders: selectedShipperOrders,
      });
  }, [selectedShipperOrders, onSubmit, comment, action, logType, journeyId]);

  const handleCancelClick = useCallback(() => {
    onCancel && onCancel();
  }, [onCancel]);

  const saveButtonDisabled = !logType;

  return (
    <StyledItem background="grey200" data-testid="create-mode">
      <Flexer.Parent alignItems="center" mBottom="XS">
        <Flexer.Child flex="1">
          <ActionName action={action} bold color="grey900" />
        </Flexer.Child>
      </Flexer.Parent>

      {journeyId && (
        <Checkbox
          disabled
          checked
          label={<StyledJourneyTag data-testid="journey-tag">{`J${journeyId}`}</StyledJourneyTag>}
        />
      )}

      {!!multipleShipperOrders && (
        <>
          <StyledLogAssignation>{t.log_assignation}:</StyledLogAssignation>
          <StyledShipperOrders mBottom="XS" flexWrap="wrap" data-testid="multiple-shipper-orders">
            {Object.keys(shipperOrdersSkin).map((id) => (
              <Checkbox
                name={id}
                key={id}
                label={
                  <ShipperOrderTag
                    id={id}
                    shipperOrdersSkin={shipperOrdersSkin}
                    withinGroupage
                    copiable={false}
                    mRight="S"
                  />
                }
                onChange={handleShipperOrdersChange}
              />
            ))}
          </StyledShipperOrders>
        </>
      )}

      <Spacer mBottom="S">
        <SegmentedButton.Parent size="M" value={logType} onChange={handleLogTypeChange}>
          <SegmentedButton.Child value={LOG_INFO} label={t.info} />
          <SegmentedButton.Child value={LOG_INCIDENT} label={t.incident} />
        </SegmentedButton.Parent>
      </Spacer>

      <Textarea
        fullWidth
        value={comment}
        labelType="hidden"
        height={'100px'}
        width={'100%'}
        onChange={handleTextareaChange}
        placeholder={t.textarea_placeholder}
        fieldRef={textAreaRef}
      />
      <Flexer.Parent mTop="S" mBottom="XS" justifyContent="flex-end">
        <Flexer.Child>
          <Button skin="secondary" nude text={t.cancel} onClick={handleCancelClick} />
        </Flexer.Child>
        <Flexer.Child mRight="XS">
          <Button
            data-testid="submit-btn"
            skin="primary"
            text={t.add}
            disabled={saveButtonDisabled}
            onClick={handleSaveClick}
          />
        </Flexer.Child>
      </Flexer.Parent>
    </StyledItem>
  );
};

export default injectIntl(CreateMode);
